import { render, staticRenderFns } from "./fa-icon.vue?vue&type=template&id=56a69204"
import script from "./fa-icon.vue?vue&type=script&lang=js"
export * from "./fa-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports